import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { RippleModule } from 'primeng/ripple';
import { environment } from '../../core/environments/environment';
import { AuthService } from '../../core/service/authService.service';
import { CadastroService } from '../../core/componentes/cadastro/service/cadastro.service';
import { PessoaEditModel } from '../../core/models/pessoa-Edit.Model';
import { LoginService } from './../../core/componentes/login/service/login.service';

@Component({
  selector: 'app-selecao-sistemas',
  standalone: true,
  imports: [CommonModule, ButtonModule, RippleModule, AvatarModule, MenuModule],
  templateUrl: './selecao-sistemas.component.html',
  styleUrls: ['./selecao-sistemas.component.scss'],
})
export class SelecaoSistemasComponent implements OnInit {
  // Injeção de dependências
  router = inject(Router);
  loginService = inject(LoginService);
  authService = inject(AuthService);
  cadastroService = inject(CadastroService);

  // Propriedades do componente
  menuItems: MenuItem[] = [];
  isLoading = false;
  userAvatarUrl: string | undefined = undefined;

  ngOnInit() {
    this.inicializarMenuUsuario();
    this.verificarAutenticacao();
    this.carregarDadosUsuario();
  }

  /**
   * Carrega dados do usuário incluindo foto de perfil
   */
  private carregarDadosUsuario(): void {
    this.cadastroService.buscarUsuario().then((usuario: PessoaEditModel) => {
      // Verifica se existe uma imagem associada ao usuário
      if (usuario.imagemPerfil) {
        // Cria a URL Base64 para exibição
        this.userAvatarUrl = `data:${usuario.typeImage || 'image/png'};base64,${usuario.imagemPerfil}`;
      }
    }).catch((error) => {
      console.error('Erro ao carregar dados do usuário:', error);
    });
  }

  /**
   * Inicializa o menu do usuário
   */
  private inicializarMenuUsuario(): void {
    this.menuItems = [
      {
        label: 'Editar Perfil',
        icon: 'pi pi-user-edit',
        command: () => this.editarPerfil(),
      },
      // {
      //   label: 'Configurações',
      //   icon: 'pi pi-cog',
      //   command: () => this.configuracoes()
      // },
      {
        separator: true,
      },
      {
        label: 'Sair',
        icon: 'pi pi-sign-out',
        command: () => this.logout(),
      },
    ];
  }

  /**
   * Verifica autenticação do usuário
   */
  private verificarAutenticacao(): void {
    this.authService.validateToken().subscribe({
      next: (token: boolean) => {
        if (!token) {
          this.router.navigate(['/']);
        }
      },
      error: () => {
        this.router.navigate(['/']);
      },
    });

    // Verifica role específica
    this.loginService.verificarRoleERedirecionar(
      'PESSOA_NOMOH_ADM',
      '/dashboard'
    );
  }

  /**
   * Acessa o sistema Portal
   */
  acessarPortal(): void {
    this.adicionarLoadingState('.n-portal');

    setTimeout(() => {
      this.router.navigate(['/portal']);
    }, 800);
  }

  /**
   * Acessa o sistema Bardo
   */
  acessarBardo(): void {
    this.adicionarLoadingState('.n-bardo');

    setTimeout(() => {
      // Redireciona para o Bardo usando a URL do environment
      window.location.href = environment.redirectBardo;
    }, 800);
  }

  /**
   * Navega para edição de perfil
   */
  editarPerfil(): void {
    this.router.navigate(['/editar']);
  }

  /**
   * Navega para configurações
   */
  configuracoes(): void {
    this.router.navigate(['/configuracoes']);
  }

  /**
   * Realiza logout do usuário
   */
  logout(): void {
    this.isLoading = true;

    this.loginService.logout().subscribe({
      next: () => {
        document.location.href = environment.redirect401Url;
      },
      error: (error) => {
        this.isLoading = false;
        console.error('Logout error:', error);
      },
    });
  }

  /**
   * Adiciona estado de loading a um card específico
   */
  private adicionarLoadingState(selector: string): void {
    const element = document.querySelector(selector) as HTMLElement;
    element?.classList.add('loading');
  }

  /**
   * Navega para acesso rápido - Perfil
   */
  acessoRapidoPerfil(): void {
    this.router.navigate(['/perfil']);
  }

  /**
   * Navega para acesso rápido - Agenda
   */
  acessoRapidoAgenda(): void {
    this.router.navigate(['/agenda']);
  }

  /**
   * Navega para acesso rápido - Configurações
   */
  acessoRapidoConfiguracoes(): void {
    this.router.navigate(['/configuracoes']);
  }
}
